import React from 'react';
import { CheckIcon } from 'lucide-react';
import { pricing } from '../data/content';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
const offerItems = ['6 módulos especializados', '+400 páginas de material profesional', `5 bonos profesionales GRATIS — valorados en ${pricing.bonusTotal}`, 'Acceso inmediato', 'Acceso de por vida'];
export function Offer() {
  return <section id="oferta" className="scroll-mt-16 bg-paper py-20 sm:py-24" aria-labelledby="offer-title" data-id="element-148" data-mp="tzwhnj3w16h1">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-149" data-mp="p0tk0jq8m2j3">
        <div className="text-center" data-id="element-150" data-mp="13wre7wglowso">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-151" data-mp="13xsq235fxnbg">Acceso completo a Maestro de Sesiones</p>
          <h2 id="offer-title" className="mt-4 text-balance font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-152" data-mp="ywmw6201nu0c">
            Todo el sistema por solo <em className="text-terra" data-id="element-153" data-mp="2adwdoizm4bz0">{pricing.today}</em>
          </h2>
        </div>

        <div className="mt-10 rounded-[2rem] bg-cream p-7 shadow-soft ring-1 ring-cream-line sm:p-12" data-id="element-154" data-mp="pkh3z3r2mici">
          <ul className="mx-auto max-w-md space-y-3" data-id="element-155" data-mp="uisfrk0xf2xd">
            {offerItems.map(item => <li key={item} className="flex items-start gap-3 text-lg text-petrol" data-id="element-156" data-mp="zhvc8g2uc0tq">
                <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-deep text-paper" data-id="element-157" data-mp="13k05hdpdmvfu">
                  <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-158" data-mp="6uir8acbw12j" />
                </span>
                {item}
              </li>)}
          </ul>

          <div className="mt-10 border-t border-cream-line pt-10 text-center" data-id="element-159" data-mp="funv4aibchby">
            <p className="font-display leading-none text-petrol" data-id="element-160" data-mp="fskz99uhbtzb">
              <span className="mr-3 align-middle text-2xl text-terra sm:text-3xl" data-id="element-161" data-mp="kmp3hlcd1nwp">HOY:</span>
              <span className="text-6xl sm:text-7xl" style={{
              fontSize: "40px"
            }} data-id="element-162" data-mp="3k84887lde6ze">{pricing.today}</span>
            </p>
            <p className="mx-auto mt-5 w-fit rounded-md bg-sage-wash px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-sage-deep" data-id="element-163" data-mp="3o84lhowqgc4v">
              Pago único · Sin suscripciones
            </p>
            <div className="mt-8" data-id="element-164" data-mp="qetgftxnmqst">
              <CtaButton checkout block data-id="element-165" data-mp="1561ztlayrfxi">
                Quiero acceder a Maestro de Sesiones
              </CtaButton>
            </div>
            <div className="mt-5" data-id="element-166" data-mp="106z5ovwiuu4b">
              <TrustRow data-id="element-167" data-mp="cgv4ev6t36gh" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}